UnavailableTypesStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  UnavailableTypesStore.dispatchCallback,
);

UnavailableTypesStore.unavailable_types = {};

UnavailableTypesStore.onUnavailablesHandler = function (unavailableTypesData, response) {
  unavailableTypesData.reset(response.data.unavailable_types);
  UnavailableTypesStore.unavailable_types = response.data.unavailable_types;
  UnavailableTypesStore.trigger('unavailable_types:load:success');
};

UnavailableTypesStore.onUnavailablesError = function (error) {
  UnavailableTypesStore.trigger('unavailable_types:load:error', error);
};

UnavailableTypesStore.getAllUnavailableTypes = function () {
  return UnavailableTypesStore.unavailable_types;
};
